// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import Vue from 'vue';
import VueResource from 'vue-resource';
// import Raven from 'raven-js';
// import RavenVue from 'raven-js/plugins/vue';
import BootstrapVue from 'bootstrap-vue';

import App from './App';
import router from './router';

// if (
//   process.env.NODE_ENV === 'production' &&
//   process.env.RAVEN_KEY &&
//   process.env.RAVEN_PROJECT
// ) {
//   Raven
//     .config(`https://${process.env.RAVEN_KEY}@sentry.io/${process.env.RAVEN_PROJECT}`)
//     .addPlugin(RavenVue, Vue)
//     .install();
// } else {
//   console.log('Raven disabled. Add RAVEN_KEY & RAVEN_PROJECT');
// }

Vue.use(VueResource);
Vue.use(BootstrapVue);

// Vue.component('alert', require('vue-strap').alert);
// Vue.component('datePicker', require('vue-strap').alert);
console.log('API', process.env.API_HOST);
Vue.http.options.root = process.env.API_HOST;
Vue.http.headers.common['Content-Type'] = 'application/json';
// Vue.http.options.emulateJSON = true;
Vue.http.headers.common.Accept = 'application/json';
// Vue.http.headers.common['Access-Control-Allow-Origin'] = '*';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});
//
// router.beforeEach((to, from, next) => {
//   if (to.query.token) {
//
//     if (to.query.product) {
//       next({
//         path: to.path,
//         query: {
//           product: to.query.product
//         }
//       });
//     } else {
//       next({
//         path: to.path,
//         query: false
//       });
//     }
//   } else {
//     next();
//   }
// });



// WEBPACK FOOTER //
// ./src/main.js